import { TESTING_CALENDAR_VIEW_ROLES } from '@/config/testingCalendar'

/** Who may open the proctor testing accommodations page. */
export function canViewTestingAccommodationsPage(user) {
  if (!user?.role) return false
  if (TESTING_CALENDAR_VIEW_ROLES.includes(user.role)) return true
  return user.testingAccess === true
}

/** Admin panel: who may configure school-wide proctor roster tabs. */
export const PROCTOR_TAB_ADMIN_ROLES = [
  'admin',
  'district_admin',
  'school_admin',
  'admin_504',
  'sped_chair',
  'sped_chair_all',
  'staff_view',
  'staff_edit',
  'staff_edit_docs',
  'school_psych'
]

export function canManageProctorTabs(user) {
  if (!user?.role) return false
  return PROCTOR_TAB_ADMIN_ROLES.includes(user.role)
}

/** Mark present / save session notes on the proctor roster. */
export function canRecordTestingAttendance(user) {
  if (!user?.role) return false
  if (user.testingAccess === true) return true
  return PROCTOR_TAB_ADMIN_ROLES.includes(user.role)
}

/** Case-manager-style roles are scoped to their own caseload in the log. */
const CASE_MANAGER_LOG_ROLES = ['case_manager', 'case_manager_full', 'speech_case_manager']

/** Teacher-style roles are scoped to their own classes in the log. */
const TEACHER_LOG_ROLES = ['teacher', 'teacher_full', 'service_provider']

const TEACHER_LOG_ALL_ROLES = [...CASE_MANAGER_LOG_ROLES, ...TEACHER_LOG_ROLES]

/** Teachers see attendance marked for their classes. */
export function canViewTeacherAttendanceLog(user) {
  if (!user?.role) return false
  if (canRecordTestingAttendance(user)) return true
  if (PROCTOR_TAB_ADMIN_ROLES.includes(user.role)) return true
  return TEACHER_LOG_ALL_ROLES.includes(user.role)
}

/**
 * Which slice of the attendance log a user sees:
 *  - 'school'      → proctors/admins: whole school (may filter).
 *  - 'caseManager' → case managers (incl. *_full): only their caseload (FERPA).
 *  - 'teacher'     → teachers (incl. teacher_full): only their own classes.
 *  - null          → no access.
 * Note: teacher_full / case_manager_full are intentionally scoped to their own
 * students here — they can technically read more, but the log stays focused on
 * the students they actually care about.
 */
export function testingAttendanceLogScope(user) {
  if (!user?.role) return null
  if (canRecordTestingAttendance(user)) return 'school'
  if (CASE_MANAGER_LOG_ROLES.includes(user.role)) return 'caseManager'
  if (TEACHER_LOG_ROLES.includes(user.role)) return 'teacher'
  return null
}
